import { getTimelineInterval } from "Areas/SharedFeatures/downSidePanel/redux/selectors";
import { connect } from "react-redux";
import { getLinesOrAreas, getSelectedLinesOrAreas } from "../redux/selectors";
import LinesOrAreasLayer from "./linesOrAreasLayer";
const mapStateToProps = (state) => ({
    data: getLinesOrAreas(state),
    selected: getSelectedLinesOrAreas(state),
    hasTimelineIntervalFilter: Boolean(getTimelineInterval(state))
});
export default connect(mapStateToProps)(LinesOrAreasLayer);
